/* ══════════════════════════════════════════════════════════════════════
   KELVIN — filtres de collection                    Claude, 2026-09-15
   Filtrer, trier et densifier SANS recharger la page : c'est la
   « fluidité d'utilisation » demandée.

   ⚠ RÈGLE ABSOLUE DE CE FICHIER : il ne REMPLACE jamais le HTML des
   cartes, et n'écoute jamais `[data-ajout]`.

   Pourquoi : `kelvin-motion-la.js` (L550) attache l'ajout au panier
   bouton par bouton, au chargement — pas en délégation. Deux
   conséquences, toutes deux déjà payées sur ce projet :
     · réécrire la grille (Section Rendering API, innerHTML) livrerait
       des boutons SANS gestionnaire, donc muets ;
     · ajouter ici un écouteur délégué sur `[data-ajout]` en donnerait
       DEUX aux boutons existants, soit deux POST /cart/add.js par clic.
   On se contente donc de masquer, de démasquer et de DÉPLACER des nœuds
   existants : déplacer un nœud conserve ses écouteurs.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__kelvinFiltres) return;
  window.__kelvinFiltres = true;

  var MEMOIRE = 'kelvin:densite';

  function demarrer(kf) {
    var grille = document.querySelector('.sq-grille');
    if (!grille) return;

    var cartes = Array.prototype.slice.call(grille.querySelectorAll('.sq-carte'));
    var pastilles = Array.prototype.slice.call(kf.querySelectorAll('[data-kf-lien]'));
    var compte = kf.querySelector('[data-kf-compte]');
    var select = kf.querySelector('[data-kf-tri]');
    var densites = Array.prototype.slice.call(kf.querySelectorAll('[data-kf-densite]'));

    /* Le serveur a déjà filtré (URL /collections/x/tag) : la grille ne
       contient qu'un sous-ensemble. Filtrer par-dessus mentirait, et
       « tout » n'aurait rien à remontrer. On laisse alors les liens
       naviguer normalement — c'est correct, juste moins fluide. */
    var filtreServeur = kf.getAttribute('data-kf-serveur') === '1';

    /* L'ordre d'origine est la « sélection » du marchand : on le garde
       pour pouvoir y revenir sans recharger. */
    var ordreInitial = cartes.slice();

    var vide = null;
    function messageVide(afficher) {
      if (afficher && !vide) {
        vide = document.createElement('p');
        vide.className = 'kf__vide';
        vide.setAttribute('role', 'status');
        vide.textContent = 'aucun produit dans cette sélection';
        grille.parentNode.insertBefore(vide, grille.nextSibling);
      } else if (!afficher && vide) {
        vide.remove();
        vide = null;
      }
    }

    function tagsDe(carte) {
      return (carte.getAttribute('data-kf-tags') || '').split(' ').filter(Boolean);
    }

    function appliquer(tag) {
      var visibles = 0;
      cartes.forEach(function (c) {
        var ok = !tag || tagsDe(c).indexOf(tag) !== -1;
        /* `hidden` plutôt que `display:none` en ligne : l'attribut sort
           l'élément du parcours clavier et de l'arbre d'accessibilité,
           et se lit dans le DOM sans ouvrir les styles calculés. */
        c.hidden = !ok;
        if (ok) visibles++;
      });

      pastilles.forEach(function (a) {
        var sien = a.getAttribute('data-kf-lien');
        var actif = sien === tag || (!tag && !sien);
        a.classList.toggle('is-actif', actif);
        if (actif) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });

      if (compte) {
        compte.textContent = visibles + ' produit' + (visibles > 1 ? 's' : '');
      }
      messageVide(visibles === 0);
      kf.setAttribute('data-kf-tag', tag || '');
    }

    /* --- filtrer ---------------------------------------------------- */
    if (!filtreServeur) {
      pastilles.forEach(function (a) {
        a.addEventListener('click', function (e) {
          /* Un clic milieu, ⌘/ctrl-clic ou shift-clic doit continuer
             d'ouvrir un onglet : on ne détourne que le clic simple. */
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          var tag = a.getAttribute('data-kf-lien') || '';
          appliquer(tag);
          try {
            history.pushState({ kfTag: tag }, '', a.getAttribute('href'));
          } catch (err) {
            /* Un historique refusé (sandbox, quota) ne doit pas
               empêcher le filtre de fonctionner. */
          }
        });
      });

      /* Le bouton « précédent » doit défaire le filtre, pas sortir de
         la page : sans ceci, l'URL recule et la grille reste figée. */
      window.addEventListener('popstate', function (e) {
        var tag = (e.state && e.state.kfTag) || '';
        if (!tag) {
          var m = location.pathname.match(/\/collections\/[^/]+\/([^/?#]+)/);
          tag = m ? m[1] : '';
        }
        appliquer(tag);
      });
    }

    /* --- trier ------------------------------------------------------
       `appendChild` DÉPLACE le nœud : il garde ses écouteurs, son état
       et son focus. C'est ce qui permet de trier sans réécrire. */
    function nombre(c) {
      var v = parseFloat(c.getAttribute('data-kf-prix'));
      return isNaN(v) ? 0 : v;
    }
    if (select) {
      select.addEventListener('change', function () {
        var ordre = ordreInitial.slice();
        var v = select.value;
        if (v === 'prix-croissant') ordre.sort(function (a, b) { return nombre(a) - nombre(b); });
        else if (v === 'prix-decroissant') ordre.sort(function (a, b) { return nombre(b) - nombre(a); });
        else if (v === 'az') {
          ordre.sort(function (a, b) {
            return (a.getAttribute('data-kf-titre') || '').localeCompare(
              b.getAttribute('data-kf-titre') || '',
              'fr',
              { sensitivity: 'base' }
            );
          });
        }
        var frag = document.createDocumentFragment();
        ordre.forEach(function (c) { frag.appendChild(c); });
        grille.appendChild(frag);
      });
    }

    /* --- densité ----------------------------------------------------- */
    function poserDensite(n, memoriser) {
      grille.setAttribute('data-kf-densite', n);
      densites.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-kf-densite') === n ? 'true' : 'false');
      });
      if (!memoriser) return;
      try {
        localStorage.setItem(MEMOIRE, n);
      } catch (err) {
        /* Navigation privée ou stockage bloqué : la densité reste
           valable pour la page en cours, elle n'est simplement pas
           retenue. Jamais d'erreur visible pour ça. */
      }
    }
    densites.forEach(function (b) {
      b.addEventListener('click', function () {
        poserDensite(b.getAttribute('data-kf-densite'), true);
      });
    });

    var retenue = null;
    try {
      retenue = localStorage.getItem(MEMOIRE);
    } catch (err) {
      retenue = null;
    }
    poserDensite(retenue === '2' ? '2' : '4', false);

    /* État de départ : ce que dit l'URL, pas ce que dit le balisage. */
    if (!filtreServeur) appliquer(kf.getAttribute('data-kf-tag') || '');
  }

  function init() {
    var kf = document.querySelector('[data-kf]');
    if (kf) demarrer(kf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
